<template>
  <b-row>
    <b-col cols="12">
      <employee-leave-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import EmployeeLeaveAddForm from './EmployeeLeaveAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    EmployeeLeaveAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
